import { render, staticRenderFns } from "./SelectedFilter.vue?vue&type=template&id=f2320b56&"
import script from "./SelectedFilter.vue?vue&type=script&lang=ts&"
export * from "./SelectedFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports